import { TestDefinition, QuestionType } from '../../types';

export const TESTS_ESTRES: TestDefinition[] = [
  {
    id: 'pss-10',
    code: 'PSS-10',
    name: 'Perceived Stress Scale - 10',
    category: 'Estrés',
    description: 'Escala de 10 ítems para medir el grado en que las situaciones en la vida se perciben como estresantes. Desarrollada por Cohen et al. (1983). Autoadministrada, evalúa el estrés percibido en el último mes.',
    questions: [
      {
        id: 'q1',
        text: '1. En el último mes, ¿con qué frecuencia ha estado afectado por algo que ha ocurrido inesperadamente?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 0},
          {label: 'Casi nunca', value: 1},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 3},
          {label: 'Muy a menudo', value: 4}
        ]
      },
      {
        id: 'q2',
        text: '2. En el último mes, ¿con qué frecuencia se ha sentido incapaz de controlar las cosas importantes en su vida?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 0},
          {label: 'Casi nunca', value: 1},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 3},
          {label: 'Muy a menudo', value: 4}
        ]
      },
      {
        id: 'q3',
        text: '3. En el último mes, ¿con qué frecuencia se ha sentido nervioso o estresado?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 0},
          {label: 'Casi nunca', value: 1},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 3},
          {label: 'Muy a menudo', value: 4}
        ]
      },
      {
        id: 'q4',
        text: '4. En el último mes, ¿con qué frecuencia ha manejado con éxito los pequeños problemas irritantes de la vida?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 4},
          {label: 'Casi nunca', value: 3},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 1},
          {label: 'Muy a menudo', value: 0}
        ]
      },
      {
        id: 'q5',
        text: '5. En el último mes, ¿con qué frecuencia ha sentido que ha afrontado efectivamente los cambios importantes que han estado ocurriendo en su vida?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 4},
          {label: 'Casi nunca', value: 3},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 1},
          {label: 'Muy a menudo', value: 0}
        ]
      },
      {
        id: 'q6',
        text: '6. En el último mes, ¿con qué frecuencia ha estado seguro sobre su capacidad para manejar sus problemas personales?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 4},
          {label: 'Casi nunca', value: 3},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 1},
          {label: 'Muy a menudo', value: 0}
        ]
      },
      {
        id: 'q7',
        text: '7. En el último mes, ¿con qué frecuencia ha sentido que las cosas le van bien?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 4},
          {label: 'Casi nunca', value: 3},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 1},
          {label: 'Muy a menudo', value: 0}
        ]
      },
      {
        id: 'q8',
        text: '8. En el último mes, ¿con qué frecuencia ha sentido que no podía afrontar todas las cosas que tenía que hacer?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 0},
          {label: 'Casi nunca', value: 1},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 3},
          {label: 'Muy a menudo', value: 4}
        ]
      },
      {
        id: 'q9',
        text: '9. En el último mes, ¿con qué frecuencia ha podido controlar las dificultades de su vida?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 4},
          {label: 'Casi nunca', value: 3},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 1},
          {label: 'Muy a menudo', value: 0}
        ]
      },
      {
        id: 'q10',
        text: '10. En el último mes, ¿con qué frecuencia se ha sentido al control de todo?',
        type: QuestionType.LIKERT,
        options: [
          {label: 'Nunca', value: 4},
          {label: 'Casi nunca', value: 3},
          {label: 'De vez en cuando', value: 2},
          {label: 'A menudo', value: 1},
          {label: 'Muy a menudo', value: 0}
        ]
      }
    ],
    interpretations: [
      { min: 0, max: 13, label: 'Estrés Bajo', color: 'bg-green-100 text-green-800' },
      { min: 14, max: 26, label: 'Estrés Moderado', color: 'bg-yellow-100 text-yellow-800' },
      { min: 27, max: 40, label: 'Estrés Alto', color: 'bg-red-200 text-red-900' }
    ]
  },
  {
    id: 'holmes-rahe',
    code: 'Holmes-Rahe',
    name: 'Holmes-Rahe Life Stress Inventory',
    category: 'Estrés',
    description: 'Inventario de eventos vitales estresantes. Desarrollado por Holmes y Rahe (1967). Evalúa la cantidad de estrés acumulado por cambios vitales en el último año. Versión simplificada de 30 eventos principales.',
    questions: [
      { id: 'q1', text: '1. Muerte del cónyuge', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 100}]},
      { id: 'q2', text: '2. Divorcio', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 73}]},
      { id: 'q3', text: '3. Separación matrimonial', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 65}]},
      { id: 'q4', text: '4. Encarcelamiento', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 63}]},
      { id: 'q5', text: '5. Muerte de un familiar cercano', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 63}]},
      { id: 'q6', text: '6. Lesión o enfermedad personal', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 53}]},
      { id: 'q7', text: '7. Matrimonio', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 50}]},
      { id: 'q8', text: '8. Despido del trabajo', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 47}]},
      { id: 'q9', text: '9. Reconciliación matrimonial', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 45}]},
      { id: 'q10', text: '10. Jubilación', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 45}]},
      { id: 'q11', text: '11. Cambio en la salud de un familiar', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 44}]},
      { id: 'q12', text: '12. Embarazo', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 40}]},
      { id: 'q13', text: '13. Dificultades sexuales', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 39}]},
      { id: 'q14', text: '14. Incorporación de nuevo miembro a la familia', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 39}]},
      { id: 'q15', text: '15. Reajuste de negocios', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 39}]},
      { id: 'q16', text: '16. Cambio en situación financiera', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 38}]},
      { id: 'q17', text: '17. Muerte de un amigo cercano', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 37}]},
      { id: 'q18', text: '18. Cambio a diferente tipo de trabajo', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 36}]},
      { id: 'q19', text: '19. Aumento de discusiones con el cónyuge', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 35}]},
      { id: 'q20', text: '20. Hipoteca o préstamo mayor', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 31}]},
      { id: 'q21', text: '21. Ejecución de hipoteca o préstamo', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 30}]},
      { id: 'q22', text: '22. Cambio de responsabilidades en el trabajo', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 29}]},
      { id: 'q23', text: '23. Hijo o hija que deja el hogar', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 29}]},
      { id: 'q24', text: '24. Problemas con la ley', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 29}]},
      { id: 'q25', text: '25. Logro personal destacado', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 28}]},
      { id: 'q26', text: '26. Cónyuge comienza o deja de trabajar', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 26}]},
      { id: 'q27', text: '27. Cambio de residencia', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 20}]},
      { id: 'q28', text: '28. Cambio de escuela', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 20}]},
      { id: 'q29', text: '29. Cambio en hábitos personales', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 15}]},
      { id: 'q30', text: '30. Vacaciones', type: QuestionType.LIKERT, options: [{label: 'No', value: 0}, {label: 'Sí', value: 13}]}
    ],
    interpretations: [
      { min: 0, max: 150, label: 'Bajo Riesgo - Probabilidad 30% de enfermedad', color: 'bg-green-100 text-green-800' },
      { min: 151, max: 299, label: 'Riesgo Moderado - Probabilidad 50% de enfermedad', color: 'bg-yellow-100 text-yellow-800' },
      { min: 300, max: 2000, label: 'Alto Riesgo - Probabilidad 80% de enfermedad', color: 'bg-red-200 text-red-900' }
    ]
  }
];
